var map = {
	"./can-apple.png": "X9vI",
	"./can-bellini-bliss.png": "9iLV",
	"./can-blackberry.png": "pOo7",
	"./can-blueberry-pomegranate.png": "8tra",
	"./can-cherry.png": "ybhJ",
	"./can-citrus-cherry.png": "qX2e",
	"./can-coconut-pineapple.png": "/Yg3",
	"./can-cranberry.png": "WcgN",
	"./can-grapefruit.png": "d+2Q",
	"./can-lemon.png": "5in2",
	"./can-lime.png": "eYc8",
	"./can-mango-passionfruit.png": "VhIk",
	"./can-mango.png": "YUY4",
	"./can-mangolime-bublyburst.png": "O1QD",
	"./can-mangolime-bublyburst@2x.png": "RIhb",
	"./can-mangolime-bublyburst@3x.png": "IQWT",
	"./can-orange-cream.png": "laG3",
	"./can-orange.png": "nR6h",
	"./can-passionfruit.png": "mgXM",
	"./can-peach.png": "xHhe",
	"./can-peachmango-bublyburst.png": "7b5Q",
	"./can-pineapple.png": "LH5y",
	"./can-raspberry.png": "x+wA",
	"./can-strawberry-sunset.png": "Wj/9",
	"./can-strawberry.png": "Mhoa",
	"./can-triple-berry.png": "/knL",
	"./can-tripleberry-bublyburst.png": "calc",
	"./can-watermelon.png": "7OX6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "x2oG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans ^\.\/can\-.*\.png$
// module id = x2oG
// module chunks = 0